import React from "react";
import { useNavigate } from "react-router-dom";
import flashSale from "../../assets/images/banner/VirtualTryOnVideo14_2.mp4";

const Banner12 = () => {
  const navigate = useNavigate();

  const handleBannerClick = () => {
    const message = "Flash Sale Eyeglasses";
    const key = "ca_id";
    const value = 2;
    const table = "getallproduct";
    navigate("/prodList", { state: { message, key, value, table } });
  };

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "auto",
    overflow: "hidden",
    cursor: "pointer",
  };

  return (
    <div>
      {/* Banner Section */}
      <div style={containerStyle} >
        <video
          src={flashSale}
          style={{ width: "100%", height: "auto", display: "block" }}
          autoPlay
          loop
          muted
          playsInline
        />
      </div>

      {/* Divider Section */}
      <div className="px-4">
        <div className="flex items-center justify-center my-6">
          <div className="w-full border-t border-gray-300"></div>
          <span className="mx-4 text-black text-sm md:text-base font-semibold whitespace-nowrap">
            CONTACT LENSES
          </span>
          <div className="w-full border-t border-gray-300"></div>
        </div>
      </div>
    </div>
  );
};

export default Banner12;
